import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { useEffect, useState, useRef } from "react";
import { useTranslation } from "react-i18next";
import { MdArrowBack } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Dialog, DialogActions, DialogContent, Button, DialogContentText, DialogTitle } from "@mui/material";
import { web_url } from "../../constant";


function ResearcherPenpalMatchingManual2() {
    const [language, setLanguage] = useState(() => {
        const categoryNow = localStorage.getItem('language') ? localStorage.getItem('language') : 'English';
        return categoryNow;
    })
    const { t, i18n } = useTranslation();
    useEffect(() => {
        switch (language) {
            case 'English':
                i18n.changeLanguage('en');
                break;
            case 'Sinhala':
                i18n.changeLanguage('si');
                break;
            case 'Tamil':
                i18n.changeLanguage('ta');
                break;
            default:
                i18n.changeLanguage('en');
                break;
        }
        localStorage.setItem('language', language);
    }, [language]);

    const navigate = useNavigate();
    const [open, setOpen] = useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const [open1, setOpen1] = useState(false);

    const handleClickOpen1 = () => {
        setOpen1(true);
    };

    const handleClose1 = () => {
        setOpen1(false);
    };

    const [openAlert, setOpenAlert] = useState(false);

    const handleClickOpenAlert = () => {
        setOpenAlert(true);
    };

    const handleCloseAlert = () => {
        setOpenAlert(false);
    };

    const changeLanguage = (lang) => {
        i18n.changeLanguage(lang);
    };


    const [openError, setOpenError] = useState(false);
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false)

    const handleClickOpenError = (err) => {
        if (err.toLowerCase().includes('internal server error')) {
            setError(t('t93'));
        } else if (err.toLowerCase().includes('found')) {
            setError(t('t255'));
        } else {
            setError(t('t94'));
        }
        setOpenError(true);
    };

    const handleCloseError = () => {
        setOpenError(false);
        navigate('/researcher/penpalmatching')
    };


    const [isControlSelected, setIsControlSelected] = useState(null);

    const [penpalSelected, setPenPalSelected] = useState(() => {
        const storedStudents = localStorage.getItem('studentSelected');
        const parsedStudents = storedStudents ? JSON.parse(storedStudents) : [];
        return parsedStudents.length > 0 ? [parsedStudents[0].userEmail, parsedStudents[1].userEmail] : [];
    })

    const [errorGrp, setErrorGrp] = useState(false)

    const handleClick = () => {

        if (isControlSelected === null) {
            setErrorGrp(true);
            return;
        }

        setErrorGrp(false);
        setIsLoading(true);
        const formData = new FormData();
        const typeStudent = isControlSelected ? "CONTROL" : "TREATMENT";
        formData.append('studentEmail', penpalSelected[0]);
        formData.append('penpalEmail', penpalSelected[1]);
        formData.append('penpalGroup', typeStudent);

        console.log('Form Data:', {
            studentEmail: penpalSelected[0],
            penpalEmail: penpalSelected[1],
            penpalGroup: typeStudent
        });

        const getLogDetails = () => {
            return JSON.parse(localStorage.getItem("logDetails")) || JSON.parse(sessionStorage.getItem("logDetails"));
        };
        const logDetails = getLogDetails();

        axios.put(`${web_url}/api/auth/students/update-penpal`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                "Authorization": `Bearer ${logDetails.token}`
            },
        }
        ).then((response) => {
            setIsLoading(false);
            navigate('/researcher/penpalmatching')
        }).catch((err) => {
            console.error('Error:', err);
            if (err.response.data.message) {
                handleClickOpenError(err.response.data.message)
            } else {
                handleClickOpenError("error occured")
            }
            setIsLoading(false);
        });
    }


    const [studentsselected, setStudentsSelected] = useState(() => {
        const storedStudents = localStorage.getItem('studentSelected');
        return storedStudents ? JSON.parse(storedStudents) : [];
    })

    return (
        <div className={`${i18n.language === "en" ? "font-urban" : (i18n.language === "si" ? "font-noto" : "font-mukta")}  w-screen xl:pt-[20px]`}>
            {
                isLoading ?
                    <div className="items-center justify-center flex pt-[100px]">
                        <div className='w-10 h-10 border-2 border-t-transparent border-[#FFA803] rounded-full animate-spin'></div>
                    </div>
                    :
                    <div>
                        <div className="pb-[120px] xl:hidden">
                            <div className={`${i18n.language === "en" ? "font-urban" : (i18n.language === "si" ? "font-noto" : "font-mukta")} pl-[30px] pr-[30px] md:items-center pt-[80px] md:pt-[120px] lg:pt-[140px] xl:pt-[10px] 2xl:pt-[20px]`}>
                                <div className="flex items-center justify-start mt-[20px] md:ml-[70px]">
                                    <MdArrowBack size={25} className="md:hidden" onClick={() => {
                                        navigate('/researcher/penpalmatching')
                                    }} />
                                    <MdArrowBack size={30} className="hidden md:block xl:hidden" onClick={() => {
                                        navigate('/researcher/penpalmatching')
                                    }} />
                                    <MdArrowBack size={30} className="hidden xl:block" onClick={() => {
                                        navigate('/researcher/penpalmatching')
                                    }} />
                                    <p className={`font-bold ml-[10px] ${i18n.language === "en" ? "text-[17px] md:text-[25px] lg:text-[33px] xl:text-[15px] 2xl:text-[22px]" : (i18n.language === "si" ? "text-[14px] md:text-[19px] lg:text-[27px] xl:text-[13px] 2xl:text-[18px]" : "text-[14px] md:text-[19px] lg:text-[27px] xl:text-[13px] 2xl:text-[18px]")}`}>{t('t455')}</p>
                                    {/* <MdInfoOutline className="ml-[10px] text-[#1E2533] cursor-pointer text-[20px] md:text-[27px] lg:text-[32px]" /> */}
                                </div>
                                <div className="md:ml-[70px]">
                                    <p className={`text-start font-bold ml-[10px] text-[#1E2533] mt-[10px] ${i18n.language === "en" ? "text-[19px] md:text-[24px] lg:text-[28px] xl:text-[27px] 2xl:text-[28px]" : (i18n.language === "si" ? "text-[17px] md:text-[20px] lg:text-[23px] xl:text-[22px] 2xl:text-[18px]" : "text-[16px] md:text-[21px] lg:text-[22px] xl:text-[20px] 2xl:text-[18px]")}`}>
                                        {t('t459')}
                                    </p>
                                    <p className={`text-start font-[500] ml-[10px] text-[#4B5563] mt-[5px] ${i18n.language === "en" ? "text-[15px] md:text-[20px] lg:text-[23px] xl:text-[27px] 2xl:text-[28px]" : (i18n.language === "si" ? "text-[12px] md:text-[16px] lg:text-[18px] xl:text-[22px] 2xl:text-[18px]" : "text-[11px] md:text-[15px] lg:text-[18px] xl:text-[20px] 2xl:text-[18px]")}`}>
                                        {t('t461')}
                                    </p>
                                </div>
                            </div>

                            <div className="mt-[20px] md:mt-[40px]  px-[20px] md:px-[120px] lg:px-[160px] xl:px-[90px] ">

                                {
                                    studentsselected.length > 0 ?
                                        <>

                                            <div className="max-h-[42vh]  overflow-y-auto px-4 xl:grid grid-cols-3 xl:gap-[20px]">
                                                {
                                                    studentsselected.map((student, index) => {
                                                        const isSelected = penpalSelected.includes(student.userEmail);
                                                        return (
                                                            <div key={index} className="flex justify-center items-center gap-[5px] md:gap-[20px]">
                                                                <div className={`cursor-pointer text-[#8189B0] border border-[#8189B0] bg-[#F1F6FB]  w-full py-[10px] flex justify-center items-center rounded-md mb-[10px]`}>
                                                                    <div className="flex flex-col items-center">
                                                                        <p className=" text-[17px] font-bold">{student.userFullName}</p>
                                                                        <p className=" text-[16px]">{student.userEmail}</p>
                                                                        <p className=" text-[16px]">{student.ethnicity}</p>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                        </>
                                        :
                                        <div className="flex justify-center pt-[40px]">
                                            <p className="text-[15px] md:text-[20px] xl:text-[17px] text-black font-bold">{t('t285')}</p>
                                        </div>

                                }
                            </div>

                            {
                                studentsselected.length > 0 &&
                                <div className="sticky bottom-0 pt-[5px] md:pt-[15px] pb-[5px] flex justify-center px-[35px] md:px-[140px] ">
                                    <div className="w-full xl:w-[500px] 2xl:w-[600px] md:w-[600px] flex justify-center gap-[20px]">
                                        <button onClick={() => { setIsControlSelected(false) }} className={`font-[600] xl:hidden w-[70%] ${isControlSelected !== null && !isControlSelected && "bg-opacity-40"} bg-[#0E141F] text-white px-[20px] py-[10px] md:py-[15px] 2xl:py-[15px] rounded-md`}>
                                            Treat
                                        </button>
                                        <button onClick={() => { setIsControlSelected(true) }} className={`font-[600] xl:hidden w-[70%] ${isControlSelected !== null && isControlSelected && "bg-opacity-40"} bg-[#0E141F] text-white px-[20px] py-[10px] md:py-[15px] 2xl:py-[15px] rounded-md`}>
                                            Control
                                        </button>
                                    </div>
                                </div>
                            }

                            {
                                studentsselected.length > 0 &&
                                <div className="sticky bottom-0 pt-[30px] md:pt-[55px] pb-[5px] flex justify-center">
                                    <div className="w-full xl:w-[500px] 2xl:w-[600px] md:w-[600px] flex justify-center">
                                        <button onClick={handleClick} className="font-[600] xl:hidden w-[70%] bg-[#EFAE03] text-white px-[20px] py-[10px] md:py-[15px] 2xl:py-[15px] rounded-md">
                                            {t('t283')}
                                        </button>
                                    </div>
                                </div>
                            }

                            {
                                errorGrp &&
                                <div className="sticky bottom-0 flex justify-center">
                                    <p className={`text-red-600 ${i18n.language === "en" ? "text-[14px] md:text-[21px] lg:text-[24px]" : (i18n.language === "si" ? "text-[11px] md:text-[18px] lg:text-[20px]" : "text-[11px] md:text-[17px] lg:text-[19px]")}`}>
                                        {t('t419')}
                                    </p>
                                </div>
                            }


                        </div>
                    </div>
            }


            <Dialog
                open={openError}
                onClose={handleCloseError}
                aria-labelledby="custom-dialog-title"
                aria-describedby="custom-dialog-description"
                className="backdrop-blur-sm"
            >
                <DialogTitle
                    id="custom-dialog-title"
                    className="text-2xl font-bold text-gray-800 border-b border-gray-300 pb-2"
                >
                    {t('t95')}
                </DialogTitle>
                <DialogContent className="bg-gray-50">
                    <DialogContentText
                        id="custom-dialog-description"
                        className="text-gray-600 text-md mt-2"
                    >
                        {error}
                    </DialogContentText>
                </DialogContent>
                <DialogActions className="px-4 py-2">
                    <Button
                        onClick={handleCloseError}
                        className="bg-[#F2AC0E] text-white px-4 py-2 rounded-md"
                        style={{ backgroundColor: '#F2AC0E', color: 'white', fontWeight: 'bold' }}
                    >
                        {t('t96')}
                    </Button>
                </DialogActions>
            </Dialog>

        </div>
    )
}

export default ResearcherPenpalMatchingManual2;
